import { render } from "./paySuccess.vue?vue&type=template&id=3e2c8058&scoped=true"
const script = {}

import "./paySuccess.vue?vue&type=style&index=0&id=3e2c8058&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2c8058"]])

export default __exports__